<template>
  <!-- 按钮 -->
  <div
    class="k-button k-subtitle-lg"
    :class="{
      'disabled': disabled && (!type || type === 'primary'),
      'secondary-disabled': disabled && (type === 'secondary'),
      'tertiary-disabled': disabled && (type === 'tertiary'),
      'secondary': type === 'secondary',
      'tertiary': type === 'tertiary',
      'lg': size === 'lg',
    }"
    :style="{width: width}"
    @click="onClick"
  >
    <div v-if="loading" v-loading="loading" class="loading"></div>
    <template v-else>
      <KkIcon
        v-if="beforeIcon"
        :name="beforeIcon"
        class="before-icon"
        :style="{width: size === 'lg' ? '24px' : '20px', height: size === 'lg' ? '24px' : '20px'}" />
      <slot></slot>
      <KkIcon
        v-if="afterIcon"
        :name="afterIcon"
        class="after-icon"
        :style="{width: size === 'lg' ? '24px' : '20px', height: size === 'lg' ? '24px' : '20px'}" />
    </template>
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon
  },
  props: {
    size: {
      type: String,
      default: 'md' // 'md' | 'lg'
    },
    disabled: {
      type: Boolean,
      default: false // true | false
    },
    type: {
      type: String,
      default: 'primary' // primary | secondary | tertiary
    },
    width: {
      type: String,
      default: 'auto'
    },
    beforeIcon: {
      type: String,
      default: ''
    },
    afterIcon: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return
      }
      if (this.loading) {
        // 防重点击
        return
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
.k-button {
  background: var(--kk-color-background-primary-medium);
  padding: var(--kk-spacing-4) var(--kk-spacing-6);
  border-radius: var(--kk-radius-md);
  color: #fff;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: var(--kk-color-background-primary-dark);
  }
  .loading {
    height: 24px;
  }
  ::v-deep .el-loading-mask {
    width: 0;
    left: -20px;
    top: 8px;
  }
  ::v-deep .el-loading-spinner .circular {
    width: 32px;
    height: 32px;
  }
  ::v-deep .el-loading-spinner .path {
    stroke: #ADE6EB;
  }
}
.lg {
  font-size: var(--kk-font-size-3);
  line-height: var(--kk-text-subtitle-lg-line-height);
  padding: var(--kk-spacing-4) var(--kk-spacing-7);
}
.secondary {
  box-shadow: inset 0px 0px 0px 1.5px var(--kk-color-text-primary-medium);
  background: #0000;
  color: var(--kk-color-text-primary-medium);
  &:hover {
    border-color: var(--kk-color-border-primary-dark);
    color: var(--kk-color-text-primary-dark);
    background: #0000;
  }
  ::v-deep .el-loading-spinner .path {
    stroke: var(--kk-color-text-primary-medium);
  }
}
.tertiary {
  color: var(--kk-color-text-dark);
  background: var(--kk-color-background-surface-light);
  &:hover {
    color: var(--kk-color-text-darker);
    background: var(--kk-color-background-surface-light);
  }
  ::v-deep .el-loading-spinner .path {
    stroke: var(--kk-color-text-dark);
  }
}
.disabled {
  background: var(--kk-color-background-surface-dark);
  cursor: not-allowed;
  &:hover {
    background: var(--kk-color-background-surface-dark);
  }
}
.secondary-disabled {
  color: var(--kk-color-text-light);
  border-color: var(--kk-color-text-lighter);
  cursor: not-allowed;
  box-shadow: inset 0px 0px 0px 1.5px var(--kk-color-background-surface-dark);
  &:hover {
    color: var(--kk-color-text-light);
    border-color: var(--kk-color-text-lighter);
  }
}
.tertiary-disabled {
  color: var(--kk-color-text-light);
  border-color: var(--kk-color-background-surface-light);
  cursor: not-allowed;
  &:hover {
    color: var(--kk-color-text-light);
    border-color: var(--kk-color-background-surface-light);
  }
}
.before-icon {
  margin-right: var(--kk-spacing-2);
}
.after-icon {
  margin-left: var(--kk-spacing-2);
}
</style>
